export default "/signup/_next/static/chunks/fonts/jerry-mini-7d30a19d2b3d61cbf9cf85fe9f91e9b1.woff";